import { useApolloClient } from "@apollo/client";
import { ModalOpenButton, useScreenWidth } from "@msys/ui";
import { Button, ButtonProps } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { ConfirmModal } from "../../../commons/modals/ConfirmModal.js";
import { useDiscardPendingChangesMutation } from "./DiscardPendingChangesButton.generated.js";

interface Props extends ButtonProps {
  projectId: string;
  quoteId: string;
  itemId: string;
  refetchQueries?: string[];
  handleComplete?: () => Promise<unknown> | unknown;
}

export const DiscardPendingChangesButton = ({
  projectId,
  quoteId,
  itemId,
  refetchQueries,
  handleComplete,
  ...props
}: Props) => {
  const { t } = useTranslate(["QuoteEdit", "Global"]);
  const { isMaxPhone } = useScreenWidth();
  const client = useApolloClient();
  const [discardPendingChanges, { loading }] = useDiscardPendingChangesMutation(
    { client, refetchQueries }
  );

  return (
    <ModalOpenButton
      Modal={ConfirmModal}
      modalProps={{
        handleConfirm: async () => {
          await discardPendingChanges({
            variables: {
              input: {
                projectId,
                docId: quoteId,
                itemId,
                deep: true,
              },
            },
          });
          await handleComplete?.();
        },
      }}
    >
      <Button color="warning" variant="contained" loading={loading} {...props}>
        {isMaxPhone
          ? t("Revert", { ns: "Global" })
          : t("Revert to accepted", { ns: "QuoteEdit" })}
      </Button>
    </ModalOpenButton>
  );
};
